import { render, staticRenderFns } from "./Repayments.vue?vue&type=template&id=ebbc93a8&scoped=true&"
import script from "./Repayments.vue?vue&type=script&lang=js&"
export * from "./Repayments.vue?vue&type=script&lang=js&"
import style0 from "./Repayments.vue?vue&type=style&index=0&id=ebbc93a8&prod&scoped=true&lang=css&"
import style1 from "./Repayments.vue?vue&type=style&index=1&id=ebbc93a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbc93a8",
  null
  
)

export default component.exports